import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';
import {
  mixinRobotoBold,
  mixinRobotoMedium,
  mixinRobotoRegular,
  scrollbarStyles,
} from '../../../styles';

export const StructuredChatModalStyles = css`
  ${MainStyles}
  ${scrollbarStyles}
  :host {
    --control-corner-radius: 6;
  }

  .negotiations-wrapper {
    display: flex;
    height: calc(100% - 58px);
  }

  .negotiations {
    width: 200px;
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 0 0 0 7px;
  }

  .negotiations .group-by-header {
    padding-top: 13px;
    font-size: 13px;
    color: var(--font-color-1);
    ${mixinRobotoBold}
  }

  .negotiations fast-accordion,
  .negotiations fast-accordion-item {
    border: none;
  }

  .negotiations fast-accordion {
    height: calc(100% - 75px);
    overflow: hidden auto;
  }

  .negotiations fast-accordion-item::part(button) {
    grid-area: 1 / 2 / auto / auto;
  }

  .negotiations fast-accordion-item::part(icon) {
    grid-area: 1 / 1 / auto / auto;
  }

  .negotiations fast-accordion-item::part(region) {
    padding-left: 0;
    height: 100%;
    overflow-y: auto;
  }

  .negotiations fast-accordion-item::part(heading-content) {
    font-size: 13px;
    color: var(--font-color-1);
    white-space: nowrap;
    ${mixinRobotoRegular}
  }

  .negotiations fast-accordion-item svg {
    width: 20px;
    height: 20px;
    background: rgb(255 255 255 / 7%);
    padding: 0 4px;
    border-radius: 4px;
  }

  .negotiations zero-segmented-control {
    margin-right: 8px;
  }

  .proposals-responses-wrapper {
    width: 430px;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: space-between;
    border-left: 1px solid var(--border-1);
    border-radius: calc(var(--control-corner-radius) * 1px);
    position: relative;
  }

  .proposals-wrapper {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .vppa-project-info {
    font-size: 12px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .vppa-data {
    display: flex;
    flex-direction: column;
    width: 155px;
  }

  .headers,
  .rfq-data {
    display: flex;
    flex-direction: column;
  }

  .vppa-data > span,
  .rfq-data > span,
  .headers > span {
    border-bottom: 1px solid var(--border-1);
    color: var(--white);
    padding-left: 16px;
    line-height: 28px;
    height: 28px;
    ${mixinRobotoRegular}
  }

  .headers > span {
    color: var(--font-color-1);
    ${mixinRobotoBold}
  }

  .vppa-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    height: 62px;
  }

  .vppa-info {
    display: flex;
    gap: 10px;
  }

  .vppa-status .negotiation-info {
    display: flex;
  }

  .vppa-status .negotiation-info zero-button {
    margin: 0 8px 0 0;
  }

  .vppa-status .status {
    font-size: 11px;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    line-height: 20px;
    height: 20px;
    padding: 0 6px;
    white-space: nowrap;
  }

  .vppa-status .company {
    font-size: 14px;
    line-height: 22px;
    ${mixinRobotoBold}
  }

  .vppa-status .status.inprogress {
    border-color: rgb(255 182 96 / 100%);
    background-color: rgb(255 182 96 / 29%);
  }

  .vppa-status .status.rejected,
  .vppa-status .status.tradedaway {
    border-color: var(--error);
    background-color: rgb(249 100 77 / 29%);
  }

  .vppa-status .status.successful,
  .vppa-status .status.requiresconfirmation {
    border-color: var(--completed);
    background-color: rgb(122 204 121 / 29%);
  }

  .vppa-status .actions {
    display: flex;
    gap: 0.6rem;

    --design-unit: 3;

    margin-left: auto;
  }

  .responses {
    padding: 0 1rem 1rem;
    border-top: 1px solid var(--border-1);
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .responses .inputs {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .responses .top-inputs {
    display: flex;
    column-gap: 8px;
  }

  .responses .bottom-inputs {
    display: flex;
    column-gap: 8px;
  }

  .responses .top-inputs zero-text-field {
    padding-bottom: 5px;
  }

  .responses .bottom-inputs zero-text-field,
  .responses .bottom-inputs zero-number-field {
    width: 50%;
    padding-bottom: 15px;
  }

  .responses .inputs::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: var(--white);
    opacity: 0.05;
  }

  .responses .inputs zero-text-field::part(root),
  .responses .inputs zero-number-field::part(root) {
    height: 27px;
  }

  .responses .inputs zero-text-field::part(control),
  .responses .inputs zero-text-field::part(label),
  .responses .inputs zero-number-field::part(control),
  .responses .inputs zero-number-field::part(label) {
    font-size: 12px;
  }

  .responses .inputs zero-text-field::part(label),
  .responses .inputs zero-number-field::part(label) {
    margin-bottom: 4px;
    padding-left: 0px;
  }

  .responses .actions {
    display: grid;
    column-gap: 1rem;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }

  .responses .actions zero-button {
    --design-unit: 2.7;
  }

  .vppa-data .hyperlink {
    color: var(--primary-color);
    cursor: pointer;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .vppa-data .hyperlink:hover {
    text-decoration: underline;
  }

  .proposals {
    display: flex;
    padding: 16px;
    flex-direction: column-reverse;
    row-gap: 8px;
    overflow: auto;
    max-height: calc(100% - 266px);
  }

  .chat-bubble {
    border-radius: 6px;
    background-color: #1c4351;
    width: 363px;
    align-self: flex-start;
  }

  .chat-bubble.current-user {
    background-color: #344231;
    align-self: flex-end;
  }

  .user-date {
    display: flex;
    justify-content: space-between;
    padding: 8px;
  }

  .user-date span:first-child {
    font-size: 11px;
    ${mixinRobotoMedium()}
  }

  .user-date span:nth-child(2) {
    font-size: 10px;
    color: rgb(255 255 255 / 70%);
    ${mixinRobotoRegular}
  }

  .proposal-details {
    display: flex;
    position: relative;
    height: 65px;
    width: 100%;
    justify-content: space-between;
    padding: 0 8px;
  }

  .proposal-details::before {
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
    background-color: var(--font-color-1);
    bottom: 29px;
    left: 0;
  }

  .proposal-details .column {
    position: relative;
    border-left: 1px solid var(--font-color-1);
    font-size: 11px;
    color: var(--white);
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: space-around;
    column-gap: 5px;
    text-align: center;
    align-items: flex-end;
    padding: 0 5px;
    ${mixinRobotoRegular}
  }

  .proposal-details .column > div {
    padding-bottom: 7px;
  }

  .proposal-details .column:first-child {
    border-left: none;
    padding-left: 0;
  }

  .proposal-details .column:last-child {
    padding-right: 0;
  }

  .proposal-details .column .header {
    color: var(--font-color-1);
    padding-bottom: 13px;
    ${mixinRobotoBold}
  }

  .proposal-details .column .data {
    white-space: nowrap;
    ${mixinRobotoRegular}
  }

  .proposal-details .column .data.changed-value.true {
    color: #ffb00b;
  }

  .proposal-details .column .data.changed-value.false {
    ${mixinRobotoRegular}
  }

  .proposal-details .column .master-header {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    font-size: 8.5px;
    color: rgb(135 155 166 / 80%);
    white-space: nowrap;
    ${mixinRobotoRegular}
  }

  .no-data-message {
    margin: auto;
    text-align: center;
  }

  .no-data-message p {
    font-size: 12px;
    ${mixinRobotoRegular}
  }

  .offer-status .status {
    margin: auto;
    position: relative;
    width: 88%;
    padding: 10px;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: space-between;
    font-size: 15px;
    border-width: 2px;
    border-style: dashed;
    border-radius: 4px;
    text-align: center;
    vertical-align: middle;
    line-height: 20px;
  }

  .offer-status .status.rejected,
  .offer-status .status.tradedaway {
    border-color: var(--error);
    background-color: rgb(249 100 77 / 29%);
  }

  .offer-status .status.successful,
  .offer-status .status.requiresconfirmation {
    border-color: var(--completed);
    background-color: rgb(122 204 121 / 29%);
  }

  .trade-confirmation {
    width: 100%;
    margin-top: 20px;
  }

  .top-inputs .form-control {
    display: flex;
    flex-direction: column;
  }

  .top-inputs .form-control label {
    margin: 8px 0 4px !important;
    line-height: 20px;
  }

  .proposal-header {
    padding-left: 24px;
    padding-bottom: 5px;
    font-size: 14px;
    ${mixinRobotoRegular};
  }

  .calculated-values {
    color: lightgray !important;
    font-style: italic;
  }

  .summary-title {
    display: flex;
    justify-content: space-between;
  }

  .text-red {
    color: var(--error);
  }

  .unmasking-warning {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 5px 0;
    font-size: 13px;
    ${mixinRobotoRegular};
   }

  .return-back {
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
  }

  .return-back:hover {
    cursor: pointer;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--button-hover-bg);
    border-radius: 4px;
  }

  .closing-icon {
    height: 16px;
    width: 16px;
    color: var(--gray-lighter);
  }

  .closing-icon:hover {
    height: 16px;
    width: 16px;
    color: var(--white);
  }
  .summary-title .header {
    align-self: center;
  }

    .arteria-button {
      width: 50%;
      max-width: 300px;
      margin: 0 auto;
      text-align: center;
      box-sizing: border-box;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: auto;
      vertical-align: center;
    }
`;
